import JSEncrypt from 'jsencrypt/bin/jsencrypt.min.js'

export const rsaEncryptor = {
  created () {
    if (!this.$store.getters['rsa/publicKey']) {
      this.$store.dispatch('rsa/fetchRsaPublicKey').then(_ => {})
    }
  },
  methods: {
    encrypt (data, publicKey) {
      let encryptor = new JSEncrypt()
      if (!publicKey) {
        publicKey = this.$store.getters['rsa/publicKey']
      }
      encryptor.setPublicKey(publicKey)
      return encryptor.encrypt(data)
    }
  }
}
